import { withRouter } from 'react-router-dom';

const { Component } = require('react');

/**
 * Returns the main route for a path, e.g. "/contributors/andrew" would return "contributors"
 * @param {string} path The path to parse (e.g. "/contributors/andrew")
 * @returns {string} the main route
 */
function getMainRoute(path) {
	return path.split('/').filter(str => str.length > 0)[0];
}

/**
 * When a new page is navigated to, if its main route is in this list, the scroll will reset,
 * regardless of whether the old main route and new main route are the same. For example,
 * "/contributors/andrew" to "/contributors" will reset the scroll even though the main
 * routes are the same.
 */
const alwaysResetScroll = [
	'contributors',
	'wiki'
];

// adapted from https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-every-transition
class ResetScroll extends Component {
	componentDidUpdate(prevProps) {
		const newMainRoute = getMainRoute(this.props.location.pathname);
		const oldMainRoute = getMainRoute(prevProps.location.pathname);
		/*
			The scroll resets if:
			- the new main route is defined to always reset the scroll in alwaysResetScroll
			- the new main route is different to the old main route
		*/
		if (alwaysResetScroll.includes(newMainRoute) || (newMainRoute !== oldMainRoute)) {
			setTimeout(() => {
				window.scrollTo(0, 1)
				window.scrollTo(0, 0)
			}, 0.2)
		}

		// https://stackoverflow.com/questions/31148549/scrolling-div-in-ios-causes-div-to-blank-out
		requestAnimationFrame(() => {
			const a = document.scrollingElement.scrollTop;
			return a;
		});

		setTimeout(() => {
			const a = document.scrollingElement.scrollTop;
			return a;
		}, 0.1);
	}
	
	render() {
		return this.props.children;
	}
}

export default withRouter(ResetScroll);
